import { DIMENSIONS_ORDER, DOMAIN_CLASS_BOUNDS } from "./copsoq3.constants";

/**
 * Classe étalonnée (1 à 5) d'un domaine COPSOQ III, depuis la somme brute des
 * scores de ses échelles. 0 = domaine inconnu de l'étalonnage.
 */
export function classeDomaine(domaine: string, totalBrut: number): number {
  const bornes = DOMAIN_CLASS_BOUNDS[domaine];
  if (!bornes) return 0;
  for (let i = 0; i < bornes.length; i++) {
    if (totalBrut < bornes[i]!) return i + 1;
  }
  return 5;
}

/**
 * Somme brute d'un domaine : seules les échelles que l'étalonnage lui rattache
 * comptent, comme sur la fiche résultat d'un candidat.
 */
export function totalBrutDomaine(
  domaine: string,
  scoreParEchelle: Readonly<Record<string, number>>,
): number {
  const echelles = DIMENSIONS_ORDER[domaine] ?? [];
  return echelles.reduce((somme, e) => somme + (scoreParEchelle[e] ?? 0), 0);
}
